import { transparentize } from 'polished'
import styled from 'styled-components'

export const Overlay = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 2;
    ::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 400px;
        height: calc(100% - 10px);
        background: ${({ theme }) => transparentize(0.9, theme['gray-1000'])};
    }
`

export const ModalContainer = styled.div`
    width: 380px;
    height: calc(100% - 60px);
    background-color: ${({ theme }) => theme['gray-200']};
    position: absolute;
    bottom: 0%;
    right: 10px;
    border-radius: 3px;
    transition: all 150ms linear;

    &.request-open {
        animation: entitiyEditorModalEntryAnimation 150ms linear;

        @keyframes entitiyEditorModalEntryAnimation {
            0% {
                transform: translateY(100%);
            }

            100% {
                transform: translateY(0);
            }
        }
    }

    &.request-close {
        transform: translateY(100%);
    }

    .classic-row {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        height: 100%;
    }

    .classic-col {
        display: flex;
        flex-direction: column;

        &.info {
            flex-grow: 1;
        }
    }

    .entity-modal-header {
        padding: 8px;
        display: flex;
        flex-direction: row;
        flex-grow: 0;
        height: 35px;
        color: ${({ theme }) => theme['gray-900']};
        background-color: ${({ theme }) => theme['gray-200']};
        border: 1px solid ${({ theme }) => theme['gray-400']};
        border-radius: 0px 3px 0px 0px;
        .header-title {
            font-size: 10px;
            font-family: ${({ theme }) => theme['font-bold']};
        }
        .header-subtitle {
            margin-left: 4px;
            font-size: 10px;
            color: ${({ theme }) => theme['gray-700']};
        }

        .close-button {
            margin-left: auto;
            margin-right: 8px;
            cursor: pointer;
        }
    }

    .entity-modal-body {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        padding: 8px;
        border-radius: 0px 0px 3px 0px;
        border: 1px solid ${({ theme }) => theme['gray-400']};
        border-top: none;

        .ScrollbarsCustom-Content {
            padding: 8px !important;
        }
    }

    .left-border {
        overflow: hidden;

        width: 8px;
        border-radius: 3px 0px 0px 3px;
    }

    input {
        border-radius: 3px;
        line-height: 34px;
    }

    .Select-control {
        border-radius: 3px;
    }
    .form-group {
        margin-bottom: 16px;
    }
`
